import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=024c3f9b&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=024c3f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c3f9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024c3f9b')) {
      api.createRecord('024c3f9b', component.options)
    } else {
      api.reload('024c3f9b', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=024c3f9b&scoped=true&", function () {
      api.rerender('024c3f9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QnAeRhqHcRlA/JS/comp/SearchFilterTokens.vue"
export default component.exports